import { useState } from "react";
import {useNavigate} from "react-router-dom";

function DarkLogin() {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("");
    const [passWord, setPassWord] = useState("");

    function handleLogin() {
        if (!userName) {
            alert("Please fill in your username");
            return;
        }
        if (!passWord) {
            alert("Please fill in your password");
            return;
        }
        navigate("/DarkStarGamepage")
    }
    return(
        <div className="homepage-bgimage">  
            <div className="login-buttons">
              <label className="col-form-label mt-4" for="inputDefault">Login</label>
              <input type="text" className="form-control" placeholder="Username" id="inputDefault" 
                value={userName} onChange={(e)=>setUserName(e.target.value)}/>
            </div>
            <div className="form-floating">
                <input type="password" className="form-control" id="floatingPassword" placeholder="Password"
                    value={passWord} onChange={(e)=>setPassWord(e.target.value)}/>
                <label for="floatingPassword">Password</label>
            </div>

            <button onClick={handleLogin}>
                Login
            </button>
        </div>
    );
}

export default DarkLogin;